import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";
import leave from '../component/leave.json'

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Inlogo, Bbpsasured, xopaylogo2, susimg, fineimg } from '../component/image';
import Producredu from "../component/Productedu"; 

let UserRentedu = () => { 
  let [data, setData] = useState();

  let [datae, setDatae] = useState();

  let [indexs, setIndex] = useState(0);
  let [count, setCount] = useState();

  let [pikk, setPikk] = useState(false);

  let [selas, setSelas] = useState();
  let [sel, setSel] = useState("All");

  let [selkd, setSelkd] = useState("All");

  let [selsame, setSelsame] = useState("All");
  let [allsselas, setallSelas] = useState([]);
  let [charge, setCharge] = useState();

  let [datadd, setDatadd] = useState(false);
  let [charggges, setChsrggess] = useState();

  let [ff, setFF] = useState();
  let [selkdone, setSelkdone] = useState("All");
  let [sms, setSms] = useState([]);
  let [allsselasdata, setallSelasdata] = useState();
    const [htmlString, sethtmlString] = useState("");


  let [pg_res, Setpg_res] = useState();

  let [notes, setNotes] = useState("");
  let [notesshow, setNotesshow] = useState(false);

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  const [text, setText] = useState();
  let [prepaidfees, setPrepaidfees] = useState();
  const contentRef = useRef();

  useEffect(() => {
    Start();
    User();
  }, []);

  useEffect(() => {
    Filter();
  }, [sel]);

  useEffect(() => {
    searchssnew();
    console.log(selsame, "selsame");
  }, [selsame]);


  let reelsubmit = async () => {


    console.log(selkdone, 'selkdoneselkdoneselkdone', ff)


    try {

      let pp = { id: ff._id, type: selkdone };

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/addtypepgs",
        data: pp,
      })
        .then((dat) => {
          console.log(dat, ' this is dataaaaaaaaaaaaaaaaa')

          if (dat.data.status) {
            ff.real_payment_type = selkdone;
            ff.real_payment_con_fees = JSON.stringify(dat.data.data)





          }

          window.location.reload();

        })
        .catch((ee) => {

        })


    } catch (err) {

    }

  }


 function newaddWorkingDayt3(count, twoo , hhh) {
        let currentDate = new Date(hhh); // Start with today's date
        let daysAdded = 0; // Keep track of how many valid days we've added
    
        // Helper function to check if the current date is in the 'twoo' array
        function isInTwoo(date) {
            let dateStr = date.toLocaleDateString("en-GB"); // Format date as 'DD/MM/YYYY'
            return twoo.includes(dateStr);
        }
    
        while (daysAdded < count) {
            currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
            let dayOfWeek = currentDate.getDay(); // 0 is Sunday, 6 is Saturday
    
            // Skip Sundays
            if (dayOfWeek === 0) {
                continue;
            }
    
            // Skip all Saturdays
            if (dayOfWeek === 6) {
                continue;
            }
    
            // Skip dates in the 'twoo' array
            if (isInTwoo(currentDate)) {
                continue;
            }
    
            daysAdded++; // Only increment if it's a valid day (not skipped)
        }
    
        return currentDate.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit", 
            year: "numeric",
        });
      }


  let fraud = async (tt) => {


    console.log(JSON.stringify(charge), 'kkkkk');
    try {
      let token = await localStorage.getItem("token");
      let pp = { token, userid: tt.id, verify: tt.user.fraud };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/fraud",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        fraud: true
                      }
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {

                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    fraud: true
                  }
                };

                setCharge(updatedData)



                // setFF({ ...ff, freeze: true });



              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        fraud: false
                      }
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {

              } else {

                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    fraud: false
                  }
                };

                setCharge(updatedData)
                // setFF({ ...ff, freeze: false });



              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) {

    }


  }
  let update = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, id: ff._id, change: selas };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/rentupdateedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            console.log(Jsson, "hh");
            // setData(Jsson.data);
            window.location.reload();
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  let marklist = async (tt) => {


    console.log(JSON.stringify(charge), 'kkkkk');
    try {
      let token = await localStorage.getItem("token");
      let pp = { token, userid: tt.id, verify: tt.user.marklist };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/marklist",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        marklist: true
                      }
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {

                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    marklist: true
                  }
                };

                setCharge(updatedData)



                // setFF({ ...ff, freeze: true });



              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        marklist: false
                      }
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {

              } else {

                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    marklist: false
                  }
                };

                setCharge(updatedData)
                // setFF({ ...ff, freeze: false });



              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) {

    }


  }




  function openGoogleMap(ff) {


    if (ff?.location === undefined || ff?.location === '' || ff?.location === null) {
      alert('Location Not Available')
    } else {

      let loc = JSON.parse(ff?.location)
      console.log(loc, 'gggggg')
      const url = `https://www.google.com/maps?q=${loc?.coords?.latitude},${loc?.coords?.longitude}`;
      window.open(url, '_blank');  // Opens Google Maps in a new tab
    }
  }

  let Filter = async () => {
    if (sel === "All") {
      User();
    } else {
      setIndex(0);

      try {
        let token = await localStorage.getItem("token");

        let pp = {
          token,
          limit: 10,
          skip: 0,
          search: true,
          payment_status_msg: sel,
        };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rentedu",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);

            console.log(Jsson, "Jsson");
            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    }
  };

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let User = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: 0 };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/rentedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
            setCount(Jsson.count);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  let ClickCat = (re) => {
    console.log(re, "rrrrrrrrrrrrrr");
    navigate("/category", { state: re });
  };

  function convertAndFormatTimestamp(timestamp, targetTimezone = "en-US") {
    const date = new Date(timestamp);

    const options = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZoneName: "short",
    };

    return date.toLocaleString(targetTimezone, options);
  }

  const handlePageClick = async (event) => {
    console.log(event.selected);
    setIndex(event.selected);
    if (datadd === true) {
      searchssnews(event.selected, 10);
      return;
    }

    if (sel === "All") {
      try {
        let token = await localStorage.getItem("token");

        let pp = { token, limit: 10, skip: event.selected };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rentedu",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);
            console.log(Jsson, "Jsson");
            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    } else {
      let token = await localStorage.getItem("token");

      let pp = {
        token,
        limit: 10,
        skip: event.selected,
        search: true,
        payment_status_msg: sel,
      };

      try {
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rentedu",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);

            console.log(Jsson, "Jsson");
            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    }
  };

  function convertDateString(dateString) {
    const now = new Date(dateString);

    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  let fffff = (datesss) => {
    console.log(
      datesss,
      "kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk"
    );
    const date = new Date(datesss);

    // Format the date and time
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Pad the minutes and seconds with leading zeros if necessary
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

    // Create the formatted date string
    const formattedDate = `${day}-${month}-${year} ${hours}:${formattedMinutes}:${formattedSeconds}`;

    console.log(formattedDate, "formattedDate");

    return formattedDate;
  };

  let ggfg = async () => {
    const decimalNumber = bigInt(
      "0x" + "9e672f013b1352d02bd506ad91cf58633cd8b3765686151bd53eeb2e4b3ae86f"
    ).toString(10);
    return decimalNumber;
  };

  let [ones, setones] = useState(0);
  let [twos, settwos] = useState(0);
  let [threes, setthrees] = useState(0);
  let [fouers, setfouers] = useState(0);

  let searchssnews = async (page, limit) => {
    if (selsame === "All") {
      User();
    } else {
      setIndex(page);

      try {
        let token = await localStorage.getItem("token");

        let pp = {
          token,
          limit: limit,
          skip: page,
          searchnew: true,
          payment_status_msg: sel,
          searchnewdata: selsame,
        };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rentedu",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);

            console.log(Jsson, "Jsson");
            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    }
  };

  let searchssnew = async () => {
    if (selsame === "All") {
      User();
    } else {
      setIndex(0);

      try {
        let token = await localStorage.getItem("token");

        let pp = {
          token,
          limit: 10,
          skip: 0,
          searchnew: true,
          payment_status_msg: sel,
          searchnewdata: selsame,
        };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rentedu",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);

            console.log(Jsson, "Jsson");
            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    }
  };

  let searchss = async () => {
    console.log(value, "kkkkkkkkkkkkkkkkkkkkkkkkkkkkk");
    if (value === "" || value === undefined || value === null) {
      User();
      return;
    }
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: 0, searchs: value };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/rentsearchedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
            setCount(Jsson.count);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  function addWorkingDay(count, dat, leave) {
    // Parse the input date string
    const date = new Date(dat);

    // Initialize the count of days to add
    let addedDays = 0;

    // Helper to format date for comparison
    const formatDate = (d) => d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    // Loop until we've added the required number of working days
    while (addedDays < count) {
      date.setDate(date.getDate() + 1); // Add 1 day

      // Check if the day is not Sunday and not in the leave array
      if (date.getDay() !== 0 && !leave.includes(formatDate(date))) {
        addedDays++;
      }
    }

    // Format the final date
    const formattedDate = formatDate(date);

    // Format the time
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });

    // Concatenate date and time in the desired format
    const formattedDateTime = `${formattedDate}`;

    return formattedDateTime;
  }

  let verifyy = async (tt) => {
    console.log(tt);
    try {
      let token = await localStorage.getItem("token");
      let pp = { token, verify: tt.verified, pdid: tt._id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/verifyaddedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, verified: true } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, verified: true });

              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, verified: false } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, verified: false });

              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  let Freeze = async (tt) => {
    console.log(tt);
    try {
      let token = await localStorage.getItem("token");
      let pp = { token, verify: tt.freeze, pdid: tt._id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/freezeaddedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, freeze: true } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, freeze: true });

              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, freeze: false } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, freeze: false });

              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  function newaddWorkingDay(count, twoo, date) {
    let currentDate = new Date(date); // Start with today's date
    let daysAdded = 0; // Keep track of how many valid days we've added

    // Helper function to check if the current date is in the 'twoo' array
    function isInTwoo(date) {
      let dateStr = date.toLocaleDateString("en-GB"); // Format date as 'DD/MM/YYYY'
      return twoo.includes(dateStr);
    }

    while (daysAdded < count) {
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
      let dayOfWeek = currentDate.getDay(); // 0 is Sunday, 6 is Saturday
      let dayOfMonth = currentDate.getDate(); // Get the day of the month

      // Skip Sundays
      if (dayOfWeek === 0) {
        continue;
      }

      // Skip 2nd, 4th, and 5th Saturdays
      if (dayOfWeek === 6) {
        let weekOfMonth = Math.ceil(dayOfMonth / 7); // Determine which week it is
        if (weekOfMonth === 2 || weekOfMonth === 4 || weekOfMonth === 5) {
          continue; // Skip these Saturdays
        }
      }

      // Skip dates in the 'twoo' array
      if (isInTwoo(currentDate)) {
        continue;
      }

      daysAdded++; // Only increment if it's a valid day (not skipped)
    }

    return currentDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }


  let addnotes = async (tt) => {




    if (notes === "" || notes === undefined || notes === null) {

      alert("Please enter notes");
      return;

    }
    try {

      let token = await localStorage.getItem("token");
      let pp = { token, payid: tt.pg_transactionId, msg: notes };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/addnotesedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            setNotes(Jsson?.data?.pay_notes)
            // let [ff, setFF] = useState();
            // setFF(ff.pay_notes = Jsson?.data?.pay_notes) 
            setFF(prev => ({
              ...prev,
              pay_notes: Jsson?.data?.pay_notes
            }));
            alert('notes added')
          } else {

          }
        })
        .catch((ee) => {

        });


    } catch (err) { }
  };
 let selectedddhahas = async () => {

    console.log(ff, 'ffffffffffffffffffffffffffffffffffffffffffff')

    let ggggg = `
    
    
     <!DOCTYPE html>
      <html lang="en">
  
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Receipt</title>
        <style>
            body {
                font-family: Arial, sans-serif;
            }
      
            .invoice {
                padding: 20px;
            }
      
            .invoice2 {
                height: auto;
                margin: 0 auto; 
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                padding-left : 20px;
                padding-right : 20px;
                padding-top : 30px;
            }
      
            .header {
                text-align: center;
                font-size: 24px;
                margin-bottom: 20px;
            }
      
            .details {}
      
            .item {
                display: flex;
                justify-content: space-around;
                margin-bottom: 10px;
            }
      
            .item-top {
                display: flex;
                justify-content: space-between;
            }
      
            .item span {
                flex: 1;
                text-align: center;
            }
      
            .total {
                font-weight: bold;
                font-size: 18px;
            }
      
            .divider {
              border: none;
              height: 1px;
              background-color: #ababab;
              margin: 20px 0; /* Adjust margin as needed */
              opocity: 0.1; 
              margin-top: -0px;
            }
        </style>
      </head>
  
          <body>
            <div class="invoice2">
          
          
                <div>
                    <div style=" background-color: #fff; padding : 10px ">
                        <div style="display : flex; justify-content : space-between ">
                            <div> 
                                <img style='width : 125px' src='data:image/png;base64,${fineimg}' />
                                <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ; margin-top : 20px; ">Wenoxo Technologies Pvt.Ltd.</p>
                                <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">GST Regsitration No: 33AADCW5769J1ZV</p>
                                <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">No.398A, 2nd Floor, MS Rd, Kattayanvilai,</p>
                                <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">Nagercoil, Tamilnadu 629003</p>

                            </div>
                            <div  ">
                                <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">Tax Invoice/bill of Supply/Cash Memo</p>
                                <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px; text-align : center;">(Originial for Recipient)</p>

                                <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 5px ; margin-top : 20px; ">Billing To : ${ff?.user?.name}</p>
                                <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px; width : 218px ">Address : ${ff?.aadhar?.address}</p> 

        
                            </div>
          
                        </div>
          
                    </div>

                    <hr class="divider">
        
          
          
                  <div style="display : flex; justify-content : space-between " >
                    <div > 
                      <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">Date : ${convertDateString(ff?.createdAt)}</p>
                      <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;  ">Order No : ${ff?.xopay_id}</p>
                      <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; ">Invoice Number : ${ff?.pg_transactionId}</p>
                    </div>
                    <div style="margin-top : 20px" > 
                      <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; 
                      ">Status : <span style="color : ${ff?.payment_status_msg === "Processing" ? "#F99417" : ff?.payment_status_msg === "Success" ? "#0C9C18" : "#FF0000"} ">
                      
                      ${ff?.payment_status_msg}</span></p> 
                    </div>
                  </div >

                  <table style="width :100% ; margin-top : 20px">
                    <thead style=" background-color : #A6A6A630;  ">
                      <tr>
                        <th style="padding : 15px; text-align : center ; font-size : 11px">Item</th>
                        <th style="padding : 15px; text-align : center; font-size : 11px" " >Amount(₹)</th>
                        <th style="padding : 15px; text-align : center; font-size : 11px" " >Convenience
                      Fees</th>
                        <th style="padding : 15px; text-align : center; font-size : 11px" " >HSN/SAC</th>
                        <th style="padding : 15px; text-align : center; font-size : 11px" " >Tax Rate & Type</th>
                        <th style="padding : 15px; text-align : center ; font-size : 11px"" >Tax Amount</th>
                        <th style="padding : 15px; text-align : center ; font-size : 11px"" >Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">${allsselasdata}</p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.amount}</p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.co_fess
                    }</p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px; text-align : center ">00000</p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">18%</p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.gst}</p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:700; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.totalamount}</p></td> 
                      </tr> 
                      <tr>
                        <td><p style="color : #0E0E0E ; font-weight:700; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">Grand Total</p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                        <td><p style="color : #0E0E0E ; font-weight:700; font-size : 11px ; margin-bottom : 1px ; padding : 10px; text-align : center ">₹ ${ff?.totalamount}</p></td> 
                      </tr> 

                  
                    </tbody> 
          
                  </table>
                  <hr class="divider">
          
                  
                  <div style="padding : 10px" >
                    <div style="display : flex; justify-content : space-between "  >
                    <div >

                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">
                      
                      We declare that this invoice shows the</p> 
                      <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">actual price of 
                      the services described that all particulars are true and </p> 
                      <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">correct.</p> 


                    </div >

                    <div >

                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; text-align : right  ">*This is a computer generated invoice and does not requiree</p> 
                      <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px; text-align : right   ">a physical signature </p>  
                    </div >
                    </div>
                      
                    </div>


                    
                </div>


          
            </div>
            </div>
          
          </body>
          
          </html>
  
  
  `


    sethtmlString(ggggg)


    setTimeout(() => {
      hhhfhf()
    }, 1000);






  }

  let hhhfhf = async () => {
    const element = contentRef.current;

    const canvas = await html2canvas(element, {
      scale: 6, // 🟢 Higher scale = sharper image
      useCORS: true,
    });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('receipt.pdf');
  }

   let vvback = async () => {

    console.log(ff , 'LLLLLLLLLLLLLLLLLLLLLLLL')
      setfouers(0);
                  setthrees(0);
                  settwos(0);
                  setones(0);
                  setPikk(false);

                  setFF();
                  setCharge();
                  setDatae();
                  setChsrggess();

                  Setpg_res();

                  setSms([]);
  };

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY: 'scroll', height: '100vh', scrollbarWidth: 'none' }}>
          {pikk === true ? (
            <Producredu gobackk={vvback } charge={charge} fffg={ff} smss={sms} allsselasb={[]} datadfg={data} dataedd={datae} chargggesone={charggges} />
          ) : (
            <div className="row">
              <div style={{ padding: 10, position: 'sticky', top: 0, backgroundColor: '#fff' }}>
                <div className="row">
                  <div className="col-3">
                    <input
                      onChange={(e) => {
                        inputvalue(e.target.value);
                      }}
                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Enter Order Id"
                    />
                  </div>
                  <div className="col-1">
                    <button
                      onClick={() => {
                        searchss();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                  <div className="col-8">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="next >"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      pageCount={count / 10}
                      previousLabel="< previous"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination justify-content-center"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      activeClassName="active"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      forcePage={indexs}
                    />
                  </div>
                  <div className="col-3">
                    <button
                      onClick={() => {
                        navigate("/renteditedu");
                      }}
                    >
                      {" "}
                      Edit Rent Fees
                    </button>
                  </div>
                </div>
              </div>
              <table class="table">
                <thead class="thead-dark" style={{ position: 'sticky', top: 50, backgroundColor: '#fff' }}>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col ">
                      User {"  "}
                      <select
                        onChange={(e) => {
                          setSel(e.target.value);
                          setDatadd(false);
                        }}
                        name="cars"
                        id="cars"
                      >
                        <option
                          value="All"
                          selected={sel === "All" ? true : false}
                        >
                          All
                        </option>
                        <option
                          value="Failed"
                          selected={sel === "Failed" ? true : false}
                        >
                          Failed
                        </option>
                        <option
                          value="Success"
                          selected={sel === "Success" ? true : false}
                        >
                          Success
                        </option>
                        <option
                          value="Processing"
                          selected={sel === "Processing" ? true : false}
                        >
                          Processing
                        </option>

                        <option
                          value="Refund"
                          selected={sel === "Refund" ? true : false}
                        >
                          Refund
                        </option>

                        <option
                          value="verified"
                          selected={sel === "verified" ? true : false}
                        >
                          Verified
                        </option>
                      </select>
                      <select
                        onChange={(e) => {
                          // setSel(e.target.value);
                          setSelsame(e.target.value);
                          setDatadd(true);
                        }}
                        name="cars"
                        id="cars"
                        style={{ marginLeft: 10 }}
                      >
                        <option
                          value="All"
                          selected={selsame === "All" ? true : false}
                        >
                          All
                        </option>
                        <option
                          value="Sameday"
                          selected={selsame === "Sameday" ? true : false}
                        >
                          Sameday
                        </option>
                        <option
                          value="T1"
                          selected={selsame === "T1" ? true : false}
                        >
                          T1
                        </option>
                        <option
                          value="T2"
                          selected={selsame === "T2" ? true : false}
                        >
                          T2
                        </option>
                      </select>
                    </th>
                    <th scope="col">Ids</th>
                    <th scope="col">Pg Details</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((tt, index) => {
                    let ccj = tt.charge ? JSON.parse(tt?.charge) : {};

                    console.log(tt, "tttttttt");

                    let one = 0;
                    let two = 0;
                    let three = 0;
                    let fouer = 0;
                    let five = 0;

                    let hfg = "";
                    if (tt.pg_res) {
                      hfg = JSON.parse(tt?.pg_res);
                    }

                    tt.pay.map((fff, dataff) => {
                      if (fff.payment_status_msg === "Failed") {
                        one = one + 1;
                      } else if (fff.payment_status_msg === "Processing" && fff?.freeze != true) {
                        two = two + 1;
                      } else if (fff.payment_status_msg === "Success") {
                        three = three + 1;
                      } else if (fff.payment_status_msg === "Refund") {
                        fouer = fouer + 1;
                      } else if (fff?.freeze === true) {
                        five = five + 1
                      }
                    });

                    let parsed = {};

                    if (tt?.typevalue) {
                      try {
                        parsed = JSON.parse(tt.typevalue);
                        console.error('Invalid JSON in tt.typevalue:',);
                      } catch (error) {
                        console.error('Invalid JSON in tt.typevalue:', error);
                        parsed = {}; // fallback empty object
                      }
                    }

                    return (
                      <tr style={{ cursor: "pointer" }}> 
                        <th
                          scope="row"
                          style={{ marginTop: -18, fontWeight: "700" }}
                        >
                          {index + indexs * 10 + 1}
                        </th>
                        <td
                          onClick={() => {
                            // navigate(
                            //   "/rentdetail",
                            //   { state: tt },
                            //   { merch: JSON.stringify(tt.marchantid[0]) }
                            // );

                            console.log(tt, "kkkkkkkkk");

                            setPikk(true);

                            let aaont = Number(tt.amount);
                            let amm = (1 / 100) * Number(tt.amount);

                            let ggssy = amm * 0.18;

                            setPrepaidfees(amm);
                            setText(ggssy);

                            setFF(tt);
                            setCharge(tt);
                            setDatae(tt?.marchantid[0]);
                            if (tt?.charge != undefined) {
                              setChsrggess(JSON.parse(tt?.charge));
                            }
                            if (tt?.pg_res != undefined) {
                              Setpg_res(JSON.parse(tt?.pg_res));
                            }

                            if (
                              tt?.sms?.length === 0 ||
                              tt?.sms === undefined
                            ) {
                              setSms([]);
                            } else {
                              setSms(JSON.parse(tt?.sms));
                            }

                            tt.pay.map((fff, dataff) => {
                              console.log(
                                fff.payment_status_msg,
                                "payment_status_msgpayment_status_msgpayment_status_msg"
                              );
                              if (fff.payment_status_msg === "Failed") {
                                let jh = 0;
                                jh = jh + 1;
                                setones(jh);
                              } else if (
                                fff.payment_status_msg === "Processing"
                              ) {
                                let jh = 0;
                                jh = jh + 1;
                                settwos(jh);
                              } else if (fff.payment_status_msg === "Success") {
                                let jh = 0;
                                jh = jh + 1;
                                setthrees(threes + 1);
                              } else if (fff.payment_status_msg === "Refund") {
                                let jh = 0;
                                jh = jh + 1;
                                setfouers(jh);
                              }
                            });

                            // togglePanel(tt);
                          }}
                          style={{
                            backgroundColor:
                              tt?.user?.fraud === true
                                ? "orange"
                                : tt?.user?.marklist === true
                                  ? "#fc97f1"
                                  : "#fff",
                          }}
                        >
                          <div>
                            <p style={{ fontWeight: "600", fontSize: 18 }}>
                              {tt?.user?.name}
                            </p>
                            <p style={{
                              marginTop: -12, fontWeight: "500",
                              color: "#252525B8", fontSize: 16
                            }}>
                              {tt?.user?.phoneno}
                            </p>
                            <p style={{
                              marginTop: -12, fontWeight: "500",
                              color: "#252525B8", fontSize: 16
                            }}>
                              {tt?.user?.email}
                            </p>

                            <div className="d-flex" style={{ marginTop: -12 }}>
                              <div className="d-flex ">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8", fontSize: 16, marginRight: 5
                                  }}
                                >
                                  {" "}
                                  {one}
                                </p>
                                <img
                                  src="on1.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>
                              <div className="d-flex">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8", fontSize: 16,
                                    marginRight: 5,
                                    marginLeft: 15,
                                  }}
                                >
                                  {" "}
                                  {three}
                                </p>
                                <img
                                  src="on3.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>
                              <div className="d-flex">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8", fontSize: 16,
                                    marginRight: 5,
                                    marginLeft: 15,
                                  }}
                                >
                                  {" "}
                                  {two}
                                </p>
                                <img
                                  src="on2.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>

                              <div className="d-flex">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8", fontSize: 16,
                                    marginRight: 5,
                                    marginLeft: 15,
                                  }}
                                >
                                  {" "}
                                  {fouer}
                                </p>
                                <img
                                  src="on4.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>

                              <div className="d-flex">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8", fontSize: 16,
                                    marginRight: 5,
                                    marginLeft: 15,
                                  }}
                                >
                                  {" "}
                                  {five}
                                </p>
                                <img
                                  src="on5.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>
                            </div>


                            {
                              Number(ccj?.fee) === 0 ?
                              <div style={{ marginTop: 20 }}>
                                <p style={{ color : 'red' , fontWeight : '700' }}>First Payment</p>
                              </div>

                              : ""

                            }




                          </div>
                        </td>

                        <td>
                          <div>
                            <p style={{ fontWeight: "600", fontSize: 18 }}>{tt?.pg}</p>
                            <p style={{
                              marginTop: -12, fontWeight: '500',
                              fontSize: 16, color: "#252525B8"
                            }}>
                              <span
                                style={{ fontWeight: '600', fontSize: 16, color: "#4F4F4F" }}
                              > Date :</span> {convertDateString(tt?.createdAt)}
                            </p>
                            <p style={{
                              marginTop: -12, fontWeight: '500',
                              fontSize: 16, color: "#252525B8"
                            }}>
                              <span
                                style={{ fontWeight: '600', fontSize: 16, color: "#4F4F4F" }}
                              >Xopay ID : </span>
                              {tt?.xopay_id}
                            </p>
                            <p style={{
                              marginTop: -12, fontWeight: '500',
                              fontSize: 16, color: "#252525B8"
                            }}>
                              <span
                                style={{ fontWeight: '600', fontSize: 16, color: "#4F4F4F" }}
                              >PG ID : </span>{tt?.pg_transactionId}
                            </p>

                          </div>
                        </td>
<td>
                          <div>
                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: 16,
                                  color: "#4F4F4F",
                                }}
                              >
                                Card :{" "}
                              </span>
                              { 
                               hfg?.paymentDetails?.length
                                ? hfg.paymentDetails[0]?.instrument?.cardNetwork
                                : "" }
                            </p>

                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                                marginTop: -12,
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: 16,
                                  color:  hfg?.paymentDetails?.length ? hfg.paymentDetails[0]?.instrument?.type === "CREDIT_CARD" ? "#4F4F4F" : "red" : "red",
                                }}
                              >
                                {" "}
                                Card Type :{" "} 
                              </span>
                               { 
                               hfg?.paymentDetails?.length
                                ? hfg.paymentDetails[0]?.instrument?.type
                                : "" }
                            </p>

                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                                marginTop: -12,
                              }}
                            >
                             
                            </p>

                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                                marginTop: -12,
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: 16,
                                  color: "#4F4F4F",
                                }}
                              >
                                Card Number :{" "}
                              </span>
                               { 
                               hfg?.paymentDetails?.length
                                ? hfg.paymentDetails[0]?.instrument?.maskedCardNumber
                                : "" }
                            </p>





                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color:
                                  hfg?.code === "PAYMENT_SUCCESS"
                                    ? "green"
                                    : "#252525B8",
                                marginTop: -12,
                              }}
                            >
                              {hfg?.code || hfg?.status}
                            </p>

                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                                marginTop: -12,
                              }}
                            >
                              {hfg?.message || hfg?.unmappedstatus}
                            </p>


                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: parsed?.item?.name === "AMEX" || parsed?.item?.name === "Dynex" ? "red" : "black",
                                marginTop: -12,
                              }}
                            >
                              {parsed?.item?.name}
                            </p>
                          </div>
                        </td>

                        <td>
                          <p style={{ fontWeight: "600", fontSize: 18 }}>
                            Amount : {tt?.amount}
                          </p>

                          <p style={{
                            fontWeight: '500',
                            fontSize: 16, color: "#252525B8", marginTop: -12
                          }}>
                            <span
                              style={{ fontWeight: '600', fontSize: 16, color: "#4F4F4F" }}
                            >Reward : </span>- {tt?.reward || 0}
                          </p>
                          <p style={{
                            fontWeight: '500',
                            fontSize: 16, color: "#252525B8", marginTop: -12
                          }} ><span
                            style={{ fontWeight: '600', fontSize: 16, color: "#4F4F4F" }}
                          >Conv Fee : </span>
                            {tt?.co_fess}</p>
                          <p style={{
                            fontWeight: '500',
                            fontSize: 16, color: "#252525B8", marginTop: -12
                          }}>
                            <span
                              style={{ fontWeight: '600', fontSize: 16, color: "#4F4F4F" }}
                            >Conv % : </span>{ccj?.fee}{" %"}</p>
                          <p style={{
                            fontWeight: '500',
                            fontSize: 16, color: "#252525B8", marginTop: -12
                          }} >
                            <span
                              style={{ fontWeight: '600', fontSize: 16, color: "#4F4F4F" }}
                            >Gst : </span>{tt?.gst}</p>

                          <p style={{ fontWeight: "600", fontSize: 18, marginTop: -12 }}>Total : {tt?.totalamount}</p>
                        </td>

                        <td>
                          <div>
                            <p style={{ color: '#0F3E97', fontWeight: "600", fontSize: '600' }}>
                              Priority : {ccj?.title}
                            </p>

                            <p
                              style={{
                                color:
                                  tt?.payment_status_msg === "Processing" || 
                                    tt?.payment_status_msg === "Progress"
                                    ? "orange"
                                    : tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : "green", fontWeight: "600", marginTop: -12, fontSize: 16
                              }}
                            >
                              {tt?.payment_status_msg}
                            </p>

 
                            {tt?.payment_status_msg === "Processing" || 
                              tt?.payment_status_msg === "Progress" ? ( 
                              <p style={{ fontWeight: "700", marginTop: -12 }}>

                                {ccj?.title === "T1"
                                  ? newaddWorkingDayt3(1, leave , tt?.createdAt)
                                  : ccj?.title === "Sameday"
                                    ? "4 to 5 hours"
                                    : ccj?.title === "T2"
                                      ? newaddWorkingDayt3(2, leave, tt?.createdAt)
                                      : ccj?.title === "T4" ?   newaddWorkingDayt3(4, leave, tt?.createdAt) : ccj?.title === "Low" ?
                                        newaddWorkingDayt3(7, leave, tt?.createdAt)
                                      :
                                      
                                      newaddWorkingDayt3(3, leave, tt?.createdAt) }
                              </p>
                            ) : (
                              ""
                            )}



                            { 
                              tt?.payment_status_msg === "Success" ? (
                              <p style={{ fontWeight: "700", marginTop: -12 }}>
                                 settle date : { tt?.status_update_date }
                              </p>
                            ) : (
                              ""
                            )}


                            <div className="d-flex gap-3" >
                              <button
                                onClick={() => {
                                  verifyy(tt);
                                }}
                                style={{
                                  color: "#4F4F4F", width: 100, height: 30,
                                  borderColor: "#4F4F4F"
                                }}
                              >
                                Verify
                              </button>

                              <button
                                onClick={() => {
                                  Freeze(tt);
                                }}
                                style={{
                                  color: "#4F4F4F", width: 100, height: 30,
                                  borderColor: "#4F4F4F"
                                }}
                              >
                                Freeze
                              </button>
                            </div>

                            <div className="d-flex gap-3" style={{ marginTop: 6 }} >
                              {tt?.verified === true ? (
                                <p style={{ fontWeight: "600", fontSize: 16, color: '#0F3E97' }}>
                                  Verified
                                </p>
                              ) : (
                                ""
                              )}
                              {tt?.freeze === true ? (
                                <p style={{
                                  fontWeight: "600", fontSize: 16,
                                  color: '#0F3E97'
                                }}>
                                  Freezed
                                </p>
                              ) : (
                                ""
                              )}
                            </div>

                            {/* <button
                              onClick={() => {
                                navigate("/rentdetail", { state: tt });
                              }}
                            >
                              View User
                            </button> */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>


            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserRentedu;
